// ErrorScreen.jsx
import React from 'react';

export default function ErrorScreen({ onBack }) {
  return (
    <div className="flex-1 p-6 flex flex-col items-center justify-center text-center">
      <p className="text-red-600 font-semibold mb-4">
        Unable to complete your request. Please try again.
      </p>
      <button
        onClick={onBack}
        className="bg-gray-200 hover:bg-gray-300 text-gray-700 px-4 py-2 rounded-lg transition"
      >
        Back to Summary
      </button>
    </div>
  );
}
